function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2.01491,-1.89638)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.707107,-0.707107,0.707107,0.707107,-3.42677,8.2542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.613,1.236L8.613,15.271M15.631,8.254L1.596,8.254",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(140,140,140)",
      strokeWidth: "1.32px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.762952,0,0,0.762952,2.01491,1.89638)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 17,
    height: 16,
    style: {
      fill: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseNormal);
export default __webpack_public_path__ + "static/media/close_normal.e35707b4d516084b4c63db2d9a0b0c2f.svg";
export { ForwardRef as ReactComponent };